import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import router from "../router";

import VueCookies from "vue-cookies";
Vue.use(VueCookies);
Vue.$cookies.config("7d");

import axios from "axios";
axios.create({
  baseURL: "https://api.pirls.ir/",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json"
  }
});

const store = new Vuex.Store({
  state: {
    user: null,
    loading: false,
    error: null,
    message: null,
    messageState: false,
    messageType: null,
    hasDefaultPortal: false,
    portal: null
  },
  mutations: {
    setUser: (state, payload) => {
      state.user = payload;
    },
    setLoading: (state, payload) => {
      state.loading = payload;
    },
    setError: (state, payload) => {
      state.error = payload;
    },
    setMessage: (state, payload) => {
      state.message = payload;
    },
    setMessageState: (state) => (state.messageState = true),
    setMessageType: (state, payload) => {
      state.messageType = payload;
    },
    setPortal: (state, payload) => {
      state.portal = payload;
    },
    hasDefaultPortal: (state, payload) => {
      state.hasDefaultPortal = payload;
    },
    clearUser: (state) => (state.user = null),
    clearError: (state) => (state.error = null),
    clearMessageState: (state) => (state.messageState = false)
  },
  actions: {
    signupUser: ({ commit }, payload) => {
      commit("clearError");
      commit("setLoading", true);
      axios
        .post("User/Register", payload)
        .then(() => {
          commit("setLoading", false);
        })
        .catch((err) => {
          commit("setLoading", false);
          commit("setError", err);
        });
    },
    activeUser: ({ commit }, payload) => {
      commit("clearError");
      commit("setLoading", true);
      axios
        .post("user/verifyOTP/", payload)
        .then(({ data }) => {
          const user = data.user;
          const token = data.token;
          if (user.autoGeneratePass) {
            router
              .push({ path: "SetPassword", query: { token: token } })
              .catch(() => {});
          } else {
            Vue.$cookies.set("jwt", token);
            commit("setUser", user);
            router.go();
          }
        })
        .catch((err) => {
          commit("setLoading", false);
          commit("setError", err.response.data.message);
        });
    },
    signinUser: ({ commit }, payload) => {
      commit("clearError");
      commit("setLoading", true);
      axios
        .post("User/login", payload)
        .then(({ data }) => {
          const user = data.user;
          const token = data.token;
          if (user.autoGeneratePass) {
            router
              .push({ path: "SetPassword", query: { token: token } })
              .catch(() => {});
          } else {
            Vue.$cookies.set("jwt", token);
            commit("setUser", user);
            router.go();
          }
        })
        .catch((err) => {
          commit("setLoading", false);
          commit("setError", err.response.data.message);
        });
    },
    forgotPassword: ({ commit }, payload) => {
      commit("clearError");
      commit("setLoading", true);
      axios.post("User/reqForgotPassword", payload).catch((err) => {
        commit("setLoading", false);
        commit("setMessageState");
        commit("setMessageType", "error");
        commit("setMessage", err.response.data.message);
      });
    },
    setSchoolPass: ({ commit }, payload) => {
      commit("clearError");
      commit("setLoading", true);
      const token = router.currentRoute.query.token;
      axios
        .post("user/resetSchoolPassword/", payload, {
          headers: {
            Authorization: token
          }
        })
        .then(({ data }) => {
          commit("setUser", data.user);
          router.push({ name: "Home" });
        })
        .catch((err) => {
          commit("setLoading", false);
          commit("setError", err.response.data.message);
        });
    },
    resetPassword: ({ commit }, payload) => {
      commit("clearError");
      commit("setLoading", true);
      axios
        .post("user/resetPassword/", payload)
        .then(({ data }) => {
          const user = data.user;
          const token = data.token;
          Vue.$cookies.set("jwt", token);
          commit("setUser", user);
          router.push({ name: "Home" });
        })
        .catch((err) => {
          commit("setLoading", false);
          commit("setMessageState");
          commit("setMessageType", "error");
          commit("setMessage", err.response.data.message);
        });
    },
    signoutUser: async ({ commit }) => {
      commit("setLoading", true);
      commit("clearError");
      Vue.$cookies.remove("jwt");
      commit("clearUser");
      commit("setLoading", false);
      const route = router.currentRoute.name;
      if (route == "Home") {
        router.go();
      } else {
        router.push({ name: "Home" });
      }
    },
    checkUser: ({ commit }) => {
      commit("clearError");
      commit("setLoading", true);
      const token = Vue.$cookies.get("jwt");
      if (token) {
        axios
          .get("/user/checkToken", {
            headers: {
              Authorization: token
            }
          })
          .then(({ data }) => {
            commit("setLoading", false);
            commit("setUser", data.user);
          })
          .catch(() => {
            Vue.$cookies.remove("jwt");
            commit("setLoading", false);
            commit("clearUser");
          });
      } else {
        commit("setLoading", false);
        commit("clearUser");
      }
    },
    portal: ({ commit }) => {
      commit("setLoading", true);
      const url = window.location.origin;
      axios
        .post("portal", {
          origin: url
        })
        .then(({ data }) => {
          commit("setLoading", false);
          if (data.portal.enable) {
            commit("setPortal", data.portal);
            if (data.portal.hasDefualt) {
              commit("hasDefaultPortal", true);
            } else {
              commit("hasDefaultPortal", false);
            }
          } else {
            commit("hasDefaultPortal", true);
          }
        })
        .catch(() => {
          commit("setLoading", false);
          commit("setPortal", null);
        });
    }
  },
  getters: {
    user: (state) => state.user,
    loading: (state) => state.loading,
    error: (state) => state.error,
    message: (state) => state.message,
    messageState: (state) => state.messageState,
    messageType: (state) => state.messageType,
    portal: (state) => state.portal,
    hasDefaultPortal: (state) => state.hasDefaultPortal
  }
});

export default store;
